/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const navigate = useNavigate();

  const [hidden, setHidden] = useState(false);
  const [menuMobile, setMenuMobile] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const onClickMobileMenu = () => setMenuMobile(!menuMobile);

  const homeClick = () => {
    navigate('/');
    onLinkClick();
  };
  const aboutClick = () => {
    navigate('/about');
    onLinkClick();
  };
  const onLinkClick = () => {
    window.scrollTo(0, 0);
    setMenuMobile(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 300) {
        setHidden(true); // Hide on scroll down
      } else {
        setHidden(false); // Show on scroll up
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <header
      className={`header ${hidden ? 'on-scroll-header' : ''} app-header
      ${menuMobile ? 'has-mobile-menu-open' : ''}`}
    >
      <div className="container">
        <div className="app-header__content">
          <div className="logo cursor-pointer" aria-label="Website logo">
            <img
              loading="lazy"
              alt="first-logo"
              onClick={homeClick}
              src="/common/logo.svg"
            />
          </div>

          <div className="app-header__menu-wrapper">
            <nav className="header-menu-wrapper" aria-label="Header Menu">
              <ul id="menu-header-menu" className="menu">
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <a onClick={homeClick} className="cursor-pointer" href="#">
                    Work
                  </a>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <a onClick={aboutClick} className="cursor-pointer" href="#">
                    About
                  </a>
                </li>

                <li className="menu-item menu-item-type-post_type menu-item-object-page xis-btn">
                  <a
                    className="btn"
                    href="/resume/Resume-Wilasinee-C.pdf"
                    download="Resume-Wilasinee_Chaiyong"
                  >
                    Download my resume 👈
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <img
            alt=""
            src="/images/hamburger.svg"
            className="mob-navigation-toggle"
            onClick={() => onClickMobileMenu()}
          />
        </div>
      </div>
    </header>
  );
}
